import { UAParser } from "ua-parser-js";

// this file adds a special class name on the html element, components can query by this class name for browser specific stylings
const parser = new UAParser();

const browserName = parser.getBrowser().name;
const browserType = parser.getDevice().type;

const getMobileTags = () => {
  if (browserName === "Chrome" && browserType === "mobile") {
    return {
      browserName: "mobile-chrome",
      browserType: (browserType || "").replace(/ /g, "-").toLocaleLowerCase(),
      version: parser.getEngine().version,
    };
  }
  return {
    browserName: (browserName || "").replace(/ /g, "-").toLocaleLowerCase(),
    browserType: (browserType || "").replace(/ /g, "-").toLocaleLowerCase(),
    version: parser.getEngine().version,
  };
};

export const isMobile = () => {
  const mobileTags = getMobileTags();
  return (
    ["webkit", "chrome-webview", "mobile-safari", "mobile-chrome"].indexOf(
      mobileTags.browserName
    ) > -1
  );
};

if (isMobile()) {
  const mobileTags = getMobileTags();
  document?.documentElement?.classList?.add("mobile");
  document?.documentElement?.setAttribute(
    "browser-tag",
    mobileTags.browserName
  );
  document?.documentElement?.setAttribute(
    "browser-type",
    mobileTags.browserType
  );
  document?.documentElement?.setAttribute(
    "browser-version",
    mobileTags.version || ""
  );
}
